// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__fHd-p","alert":"SettungsInbox_alert__GkEKY"};